import React from 'react';
import styled from 'styled-components';
import { Navbar } from '../components/Navbar';
import { Header } from '../components/Header';
import Slider from '../components/Slider';
import { Review } from '../components/Review';
import { Call } from '../components/Call';
import { MenuButton } from '../components/MenuButton';
import { Footer } from '../components/Footer';

export const Home = () => {
  return (
    <>
        <Container>
            <Navbar />
            <Header />
        </Container>
        <Content>
            <div className='first-section'>
                <img loading="lazy" src="assets/desc1.jpg" alt="Photo of Memories Bar" /> {/* eslint-disable-line */}
                <p>Memories bar Prokuplje. U samom centru Prokuplja, bar sa prijatnom atmosferom, ljubaznom uslugom i sirokom ponudom pića.</p>
            </div>
            <div className='second-section'>
                <img loading="lazy" src="assets/desc2.jpg" alt="Photo of Memories Bar" /> {/* eslint-disable-line */}
                <p>Najbolji espresso u gradu. Dodjite i uverite se zasto smo najbolji.</p>
            </div>

            <hr/>

            <Slider />

            <hr className="down-line" />

            <div className='instagram-link'>
                <a data-aos="zoom-in" data-aos-offset="10" data-aos-duration="1500" href="https://www.instagram.com/memories_bar_027/" target='_blank'><i className="fa-brands fa-instagram"></i></a> {/* eslint-disable-line */}
            </div>

            <div className="reviews">
                <Review text="Све препоруке. Љубазно особље, укусна храна, прелеп објекат. Приступачне цене." author="Miloš" />
                <Review text="Одлично искуство, фантастично особље, брзо, тачно, коректно! Похвала!" author="Predrag" />
                <Review text="Best espresso I've drink in Serbia till this moment.. !! Polite staff and the view on the square was unic.. totally suggest it !!!" author="Menolis" />
            </div>

            <Call />
            <div className='menu-button'>
                <MenuButton />
            </div>
            <p className='small'>Radnim danima: 07:00 - 24:00 <br /> Subotom: 07:00 - 24:00 <br /> Nedeljom: 08:00 - 24:00</p>
        
            <iframe title="Memories Bar" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2906.832609789548!2d21.584863476669398!3d43.23396907944374!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4755c393057e8dd1%3A0xe0a0d1e20e9010b6!2sMemories%20bar%20Prokuplje!5e0!3m2!1ssr!2srs!4v1710447554086!5m2!1ssr!2srs" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> {/* eslint-disable-line */}
        
            <Footer />
        </Content>
    </>
  )
}

const Container = styled.main`
    width: 100vw;
    height: 100vh;
    background-image: url('assets/heroBG.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Content = styled.div`
    background-color: rgba(0,0,0,.8);
    max-width: 1035px;
    margin: auto;

    div.first-section, div.second-section{
        img{
            display: block;
            width: 70%;
            margin: auto;
            padding-top: 2.75rem;
        }
        p{
            padding-top: 1.9rem;
            margin: auto;
            color: #fff;
            text-align: center;
            max-width: 80%;
        }
    }

    hr{
        width: 80%;
        margin: 5rem auto 2rem auto;
        border: 3px solid #cbb16d;
        border-radius: 5px;

        &.down-line{
            margin: 2rem auto 2rem auto;
        }
    }

    div.instagram-link{
        text-align: center;

        i{
            font-size: 2.75rem;
            color: #cbb16d;
            padding-bottom: 2rem;
        }
    }

    div.reviews{
        margin-bottom: 5.6rem;
    }

    div.menu-button{
        margin-top: 2rem;
        margin-bottom: 1rem;
        
        button{
            display: block;
            margin: auto;
        }
    }

    p.small{
        color: #fff;
        font-size: .7rem;
        text-align: center;
    }

    iframe{
        border: 0;
        width: 70%;
        display: block;
        margin: 4.6rem auto 2rem auto;
    }

    @media only screen and (min-width: 500px){
        div.first-section, div.second-section{
            display: grid;
            grid-template-columns: 50% 50%;
        }

        div.first-section{
            margin-bottom: 2rem;

            p{
                order: -1;
            }
        }

        iframe{
            height: 400px;
        }
    }

    @media only screen and (min-width: 945px){
        div.reviews{
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }
    }
`;
